import { TRPCClientError } from '@trpc/client';
import { trpc } from '@web-app/utils/trpc';

/**
 * Retries a read once after a 401: on tab focus, reads can race Clerk's refresh
 * of its short-lived session token. Other failures surface immediately.
 */
export const retryExpiredSession = {
  retry: (failureCount: number, error: unknown) =>
    failureCount < 1 &&
    error instanceof TRPCClientError &&
    error.data?.code === 'UNAUTHORIZED',
  retryDelay: 1_000,
};

export const supportQueryOptions = {
  staleTime: 0,
  gcTime: 0,
  ...retryExpiredSession,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  refetchInterval: false,
} as const;

/** Paginated inbox; read state is supplied by the Intercom support domain. */
export function useSupportConversations(viewerId: string, enabled: boolean) {
  return trpc.supportConcierge.conversations.useInfiniteQuery(
    { viewerId },
    {
      ...supportQueryOptions,
      enabled,
      getNextPageParam: (page) => page.nextCursor ?? undefined,
    },
  );
}
